import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// const parallaxBlock = document.getElementById('parallax-block');
//
// const sectionHeight = parallaxBlock.offsetHeight;
//
// console.log(sectionHeight)
//
// console.log(window.innerHeight)
//
// // ScrollTrigger.create({
// //     trigger: parallaxBlock,
// //     start: 'top bottom',
// //     end: 'bottom top',
// //     markers: true
// // })
// //
// //
// gsap.to('[data-speed]',{
//     y: (i, el) => (-1 * parseFloat(el.getAttribute("data-speed"))) * window.innerHeight / 100 * 50,
//     ease: 'none',
//     scrollTrigger: {
//         start: 'top bottom',
//         end: 'bottom top',
//         trigger:parallaxBlock,
//         invalidateOnRefresh: true,
//         scrub: 1,
//         markers: true,
//     }
// })

// console.log(document.querySelectorAll('[data-speed]'))

gsap.utils.toArray('[data-speed]').forEach((item) => {
    const speed = parseFloat(item.dataset.speed) || 1;
    // console.log(speed)
    // Calculate initial offset based on speed and viewport height
    // const offset = (window.innerHeight / 2) * (1 - speed);
    const offset = (window.innerHeight / 2) * (-1 * speed   );
    const initialOffset = (window.innerHeight * (speed - 1)) / 2;
    // console.log(initialOffset)

    // Set initial position below natural spot based on speed
    gsap.set(item, { y: initialOffset });

    // Apply ScrollTrigger to adjust position as you scroll
    gsap.to(item, {
        y: -initialOffset,
        ease: 'none',
        scrollTrigger: {
            trigger: item,
            start: `top-=${initialOffset} bottom`, // Start animation when the item enters the viewport
            end: `bottom-=${initialOffset} top`,   // End when item exits the viewport
            // start: `top+=${offset} bottom`, // Adjust start point dynamically for accurate center alignment
            // end: `bottom-=${offset} top`, // Adjust end point based on offset
            scrub:0.6,         // Smoothly interpolate
            markers: false,
        }
    });
});



